<script>
import { ShoppingCart, Location, Merchant } from './../../functions.js'

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'
import AlertDialogue from './../shared/AlertDialogue.vue'
import AddToCartDialogue from './../shared/AddToCartDialogue.vue'
import QuickviewDialogue from './../shared/QuickviewDialogue.vue'

export default {
  name: 'Cart',
  components: {
    Footer,
    HeaderFive,
    AlertDialogue,
    AddToCartDialogue,
    QuickviewDialogue
  },
   watch: {
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
          this.show_error = false
          this.error_message = ''
        }, 10000)
      }
    }
  },
  data () {
    return {
      ShoppingCart,
      show_error: false,
      error_message: '',
    }
  },
  methods: {
    updateQuantity(evt,product)
    {

          if(parseInt(evt.target.value) > product.quantity)
          {
            if(parseInt(product.product.stock_on_hand) >= parseInt(evt.target.value))
            {
              var dif =  parseInt(evt.target.value) - product.quantity;
              this.increaseQuantity(product, dif);
            }
            else
            {
              var invalid_amount = this.$refs.alertDialogue.show({
                  title: "Invalid Quantity",
                  message: "The entered quantity exceeds the available stock",
                  okButton: 'OK',
             
              });
              evt.target.value = product.quantity;
              evt.preventDefault();
            }
          }
          else if(parseInt(evt.target.value) < product.quantity)
          {
            if(1 <=  parseInt(evt.target.value))
            {
              var dif = product.quantity - parseInt(evt.target.value);
              this.reduceQuantity(product, dif);
            }
            else
            {
                var invalid_amount = this.$refs.alertDialogue.show({
                  title: "Invalid Quantity",
                  message: "The minimum quantity should be atleast 1",
                  okButton: 'OK',
             
              });
            evt.target.value = product.quantity;
              evt.preventDefault();
            }
          }
          else
          {
            evt.target.value = product.quantity;
            evt.preventDefault();
          }
    },
      isNumber(evt, product) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      increaseQuantity(product, quantity)
      {
        if(parseInt(product.product.stock_on_hand) > product.quantity)
        {
         var add_to_cart_response = ShoppingCart.addToCart(product.product, quantity);
           add_to_cart_response.then((response)=>{

               var modal_status = (response.status == 'success' ? 'success' : 'failed');
               var modal_custom_message = (response.status == 'success' ? '' : response.message);

               if(response.status != 'success')
               {
                 var add_cart = this.$refs.addToCartDialogue.show({
                      product: product.product,
                      status: modal_status,
                      message: modal_custom_message,
                      // okButton: 'Back to Home',
                  });
               }
           });
        }
        else
        {
          var invalid_amount = this.$refs.alertDialogue.show({
                  title: "Invalid Quantity",
                  message: "The entered quantity exceeds the available stock",
                  okButton: 'OK',
             
              });

        }
      },
      reduceQuantity(product, quantity)
      {
        if(product.quantity > 1)
        {
          var remove_from_cart_response = ShoppingCart.removeFromCart(product.product, quantity);
          remove_from_cart_response.then((response)=>{
               
          });
        }
        else
        {
           var invalid_amount = this.$refs.alertDialogue.show({
                  title: "Invalid Quantity",
                  message: "The minimum quantity should be atleast 1",
                  okButton: 'OK',
             
              });
        }
      },
      removeFromCart(product)
      {
        ShoppingCart.removeFromCart(product.product, 0);
      },
      updateCart()
      {
          ShoppingCart.setCart(ShoppingCart.cart);
          this.show_error = true;
          this.error_message = "Cart has been updated";
      },
     getProductPrice(product)
    {
      if(product.product.sale_type == 'default')
      {
        return (product.product.product_price * product.quantity);
      }
      else
      {
     
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                   
                     var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }

                  }
                }
              });
            }


             if(has_price_off_promo)
             {
              return (product.product.sale_price * product.quantity)
              
            }
            else
            {
                return (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price * product.quantity) : (product.product.product_sale_price * product.quantity));
                
            }

      }
      


      // if(product.product.sale_type == 'fixed' || product.product.sale_type == 'percentage' || product.product.sale_type == 'promo')
      // {
      //   if(product.product.sale_type == 'promo')
      //   {

      //       var has_price_off_promo = false;
      //       var price_off_promo_index = 0;
 
      //       if(product.product.promo)
      //       {
      //         product.product.promo.forEach((promo, promo_index)=>{
      //           if(typeof promo == 'object' && !Array.isArray(promo)) {
      //             if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //             {
                   
      //                var passed_product_requirements = 0;
      //              promo.required_items.forEach((ri,ri_index)=>{
      //                ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //                 if(p.product.sku == ri.sku_id)
      //                 {
      //                   passed_product_requirements+=1;
      //                 }
      //               });
      //             });

      //               if(passed_product_requirements == promo.required_items.length)
      //             {
                    
      //                 if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
      //                 {

      //                   if(has_price_off_promo)
      //                   {

      //                     if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
      //                     {
      //                       price_off_promo_index = promo_index;
      //                           has_price_off_promo = true;
      //                     }

      //                   }
      //                   else
      //                   {

      //                      price_off_promo_index = promo_index;
      //                        has_price_off_promo = true;
      //                     }
      //                 }
                 
      //             }

      //             }
      //           }
      //         });
      //       }

      //        if(has_price_off_promo)
      //        {
      //         return (product.product.promo[price_off_promo_index].promo_selling_price * product.quantity)
              
      //       }
      //       else
      //       {

      //           return (product.product.product_price * product.quantity);
      //       }

      //   }
      //   else
      //   {
      //     return (product.product.sale_price * product.quantity);
      //   }

      // }
      // else
      // {
      //   return (product.product.product_price * product.quantity);
      // }

    },
    getProductPriceSingle(product)
    {

      if(product.product.sale_type == 'default')
      {
        return (product.product.product_price);
      }
      else
      {
     
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                   
                     var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }

                  }
                }
              });
            }


             if(has_price_off_promo)
             {
              return (product.product.sale_price)
              
            }
            else
            {
                return (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price ) : (product.product.product_sale_price));
                
            }

      }

    },
    getProductPromoDescription(product)
    {
       if(product.product.sale_type == 'fixed' || product.product.sale_type == 'percentage' || product.product.sale_type == 'promo')
      {
        if(product.product.sale_type == 'promo')
        {

            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                   
                     var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }

                  }
                }
              });
            }

             if(has_price_off_promo)
             {
              return (product.product.promo[price_off_promo_index].promo_description)
              
            }
            else
            {

                return '';
            }

        }
        else
        {
          return '';
        }

      }
      else
      {
        return '';
      }

    },

    hasProductPromo(product)
    {

      if(product.product.sale_type == 'promo' && product.product.promo)
      {
        if(product.product.sale_type == 'promo')
        {

            var has_applicable_promo = false;
            var applicable_promo_index = 0;
            product.product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo)) {
              if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT' || (promo.promo_type).toUpperCase() == 'FREE GIFT')
              {
                var passed_product_requirements = 0;
                promo.required_items.forEach((ri,ri_index)=>{
                   ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                    if(p.product.sku == ri.sku_id)
                    {
                      passed_product_requirements+=1;
                    }
                  });
                });

                if(passed_product_requirements == promo.required_items.length)
                {
                
                   if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                  {

                      applicable_promo_index = promo_index;
                    has_applicable_promo = true;
                  }
                }
              }
            }
            });

            
           if(has_applicable_promo)
           {
             return true;
           }
           else
           {
             return null;
           }

        }
        else
        {
          return null;
        }

      }
      else
      {
        return null;
      }

    },

    getProductSlashedPrice(product)
    {
      if(product.product.sale_type == 'default')
      {
        return (0);
      }
      else
      {
       
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
            if(product.product.promo) {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo))
                {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                
                      var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }
                  }
                }
              });
            }


          if(has_price_off_promo)
          { 
            return (product.product.original_price * product.quantity);   
          }
          else
          {
           return (product.product.product_price == parseFloat(product.product.product_sale_price) ? 0 : (product.product.original_price * product.quantity));
          }

     

      }
     
    },
    getProductSlashedPriceSingle(product)
    {
     if(product.product.sale_type == 'default')
      {
        return (0);
      }
      else
      {
       
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
            if(product.product.promo) {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo))
                {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                
                      var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }
                  }
                }
              });
            }


          if(has_price_off_promo)
          { 
            return (product.product.original_price);   
          }
          else
          {
           return (product.product.product_price == parseFloat(product.product.product_sale_price) ? 0 : (product.product.original_price));
          }

     

      }
    }
  }
}
</script>

<template>
  <div class="page cart-page">
    <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="/static/img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                            <!-- <h6 class="section-subtitle ltn__secondary-color">//  Welcome to our company</h6> -->
                            <h1 class="section-title white-color">Cart</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Cart</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- SHOPING CART AREA START -->
    <div class="liton__shoping-cart-area mb-120">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                     <h5 v-if="show_error">{{ error_message }}</h5>
                    <div class="shoping-cart-inner" v-if="ShoppingCart.getTotalCartItems() > 0">
                        <div class="shoping-cart-table table-responsive">
                            <table class="table" v-for="cartgroup in ShoppingCart.cart">
                                <!-- <thead>
                                    <th class="cart-product-remove">Remove</th>
                                    <th class="cart-product-image">Image</th>
                                    <th class="cart-product-info">Product</th>
                                    <th class="cart-product-price">Price</th>
                                    <th class="cart-product-quantity">Quantity</th>
                                    <th class="cart-product-subtotal">Subtotal</th>
                                </thead> -->
                                <tbody v-for="cartgroup in ShoppingCart.cart">
                                    <tr v-for="product in cartgroup.products">
                                        <td>
                                          <span class="fas fa-trash" @click="removeFromCart(product)">&nbsp;</span>
                                        </td>
                                        <td class="cart-product-image">
                                            <router-link :to="{ name: 'productDetails', params: { sku_id: product.product.sku, sku_name: product.product.product_name }}"><img :src="product.product.product_image[0]" alt="#"></router-link>
                                        </td>
                                        <td class="cart-product-info">
                                            <h4><router-link :to="{ name: 'productDetails', params: { sku_id: product.product.sku, sku_name: product.product.product_name }}">{{ product.product.product_name }}</router-link></h4>
                                             <div class="promo-details text-left" v-if="hasProductPromo(product)">
                                              <small>
                                                <div v-if="hasProductPromo(product)">{{  getProductPromoDescription(product) }}</div>
                                              </small>
                                           </div>
                                        </td>
                                        <td class="cart-product-price">
                                         
                                           <span>{{ getProductPriceSingle(product) | currencyFormat }} </span><br>
                                            <del v-if="getProductSlashedPrice(product) > 0">{{ getProductSlashedPriceSingle(product) | currencyFormat }}</del>

                                        </td>
                                        <td class="cart-product-quantity">
                                            <div class="cart-plus-minus">
                                                <div class="dec qtybutton" @click="reduceQuantity(product, 1)">-</div>
                                                <input type="text" @keypress="isNumber($event)" @blur="updateQuantity($event, product)" :value="product.quantity" name="qtybutton" class="cart-plus-minus-box">
                                                <div class="inc qtybutton" @click="increaseQuantity(product, 1)">+</div>
                                            </div>
                                        </td>
                                        <td class="cart-product-subtotal">
                                              <span>{{ getProductPrice(product) | currencyFormat }} </span><br>
                                            <del v-if="getProductSlashedPrice(product) > 0">{{ getProductSlashedPrice(product) | currencyFormat }}</del>

                                      </td>
                                    </tr>           
                                </tbody>
                            </table>
                        </div>
                        <div class="shoping-cart-total mt-50">
                            
                            <table class="table">
                                <tbody>
                                   <!--   <tr>
                                        <td><h4>Cart Weight</h4></td>
                                        <td>{{ ShoppingCart.getTotalCartWeight() / 1000 }} kg</td>
                                    </tr>
                                     <tr>
                                        <td><h4>Weight Limit</h4></td>
                                        <td>{{ ShoppingCart.getCartWeightLimit() / 1000 }} kg</td>
                                    </tr> -->
                                    <tr>
                                        <td><h4>Subtotal</h4></td>
                                        <td>{{ ShoppingCart.getCartTotal() | currencyFormat }}</td>
                                    </tr>
                                   
                                </tbody>
                            </table>
                            <div class="btn-wrapper text-right">
                                <router-link to="/checkout" class="theme-btn-1 btn btn-effect-1">Proceed to Checkout</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="shoping-cart-inner-empty-cart" v-if="ShoppingCart.getTotalCartItems() <= 0">
                        <p>Your cart is empty</p>
                        <br>
                         <router-link to="/shop" class="theme-btn-1 btn btn-effect-1">Start Shopping</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- SHOPING CART AREA END -->
       <AddToCartDialogue ref="addToCartDialogue" />
   <QuickviewDialogue ref="quickviewDialogue" />
    <AlertDialogue ref="alertDialogue" />
    <Footer />
  </div>
</template>
<style>
@media screen and (min-width: 768px)
{
  div.page.cart-page td.cart-product-info {
      width: 500px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/Cart.vue